import { CheckCircle2, AlertTriangle, Loader2, Copy, XCircle } from "lucide-react";
import { STATUS_LABELS } from "../lib/format";

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS_LABELS[status] || STATUS_LABELS.offen;
  return (
    <span data-testid={testId} className={`inline-flex items-center whitespace-nowrap rounded-md border px-2 py-0.5 text-xs font-medium ${s.cls}`}>
      {s.label}
    </span>
  );
};

export const StatementBadge = ({ st, testId }) => {
  const base = "inline-flex items-center gap-1 whitespace-nowrap rounded-md border px-1.5 py-0.5 text-[11px] font-semibold";
  if (st.status === "processing")
    return <span data-testid={testId} className={`${base} border-slate-300 bg-white text-slate-600`}><Loader2 className="h-3 w-3 animate-spin" />Liest…</span>;
  if (st.status === "failed")
    return <span data-testid={testId} className={`${base} border-red-200 bg-red-50 text-red-800`}><XCircle className="h-3 w-3" />Fehler</span>;
  if (st.status === "duplicate")
    return <span data-testid={testId} className={`${base} border-red-200 bg-red-50 text-red-800`}><Copy className="h-3 w-3" />Duplikat</span>;
  if (st.balance_check?.ok)
    return <span data-testid={testId} className={`${base} border-emerald-200 bg-emerald-50 text-emerald-800`}><CheckCircle2 className="h-3 w-3" />Saldo ok</span>;
  return <span data-testid={testId} className={`${base} border-red-200 bg-red-50 text-red-800`}><AlertTriangle className="h-3 w-3" />Abweichung</span>;
};
